"use client";

import { ArrowLeft } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface BackButtonProps {
  className?: string;
  label?: string;
  variant?: "default" | "ghost" | "outline";
}

export function BackButton({
  className,
  label = "Back",
  variant = "ghost",
}: BackButtonProps) {
  const router = useRouter();
  const pathname = usePathname();

  // Don't show back button on home page
  if (pathname === "/") {
    return null;
  }

  const handleBack = () => {
    // Check if there's browser history to go back to
    if (window.history.length > 1) {
      router.back();
    } else {
      // Fallback to home page if no history
      router.push("/");
    }
  };

  return (
    <Button
      variant={variant}
      size="default"
      onClick={handleBack}
      className={cn(
        "inline-flex items-center gap-2 text-sm font-medium transition-colors",
        "hover:bg-accent hover:text-accent-foreground",
        className
      )}
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Button>
  );
}

export default BackButton;
